/* import __COLOCATED_TEMPLATE__ from './sub-comment.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ProjectsActivityListSubCommentComponent extends Component {
  @tracked isHovered = false;
  @tracked isEditing = false;

  @action
  startHover() {
    this.isHovered = true;
  }

  @action
  endHover() {
    this.isHovered = false;
  }

  @action
  startEditing(e) {
    e.preventDefault();
    console.log('startEditing');
    this.isEditing = true;
    return false;
  }

  @action
  cancelEditing() {
    this.args.comment.rollbackAttributes();
    this.isEditing = false;
  }

  @action
  async saveComment() {
    //this.args.comment.set('markers', this.args.comment.get('trackedMarkers'));
    await this.args.comment.save();
    this.args.comment.set('trackedMarkers', this.args.comment.get('markers'));
    this.isEditing = false;
  }

  @action
  async startDeleting(e) {
    e.preventDefault();
    console.log('startDeleting', this.args.commentDeleteAction);
    if (confirm('Are you sure you want to delete this comment?')) {
      let comment = this.args.comment;
      if (this.args.commentDeleteAction) {
        await this.args.commentDeleteAction(comment);
      }
      comment.deleteRecord();
      await comment.save();
    }
  }
}
